<template>
  <custom-crud-list v-bind="listConfiguration">

    <template #cell-logoImage="{ item }">
      <div style="height: 80px;">
        <img :src="item.logoImage" class="object-contain max-size-parent" />
      </div>
    </template>
    <!--
  <template #cell-introImage="{ item }">
    <block class="flex flex-center flex-middle" style="width: 100px">
      <img
        :src="item.introImage"
        style="max-height: 50px; width: auto; max-width: 100px"
        alt="" />
    </block>
  </template>
  <template #cell-price="{ item }">
    <span class="no-word-break">{{
      translateNumber(item.price, "currency", { from: item.currency })
    }}</span>
  </template>
  <template #cell-bidStarts="{ item }">
    <span class="no-word-break">{{
      item.AuctionProductType
        ? translateNumber(item.AuctionProductType.startingPrice, "currency", {
            from: item.currency,
          })
        : "-"
    }}</span>
  </template>
  <template #cell-quantity="{ item }">
    <span>{{
      item?.JustoppDealProductType?.maximumQuantity
        ? translateNumber(item?.JustoppDealProductType?.maximumQuantity)
        : "-"
    }}</span>
  </template>
  <template #cell-category="{ item }">
    <span>{{ item.Category ? item.Category.name : "-" }}</span>
  </template>
  -->
  </custom-crud-list>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";

export default {
  components: { CustomCrudList },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
    overrideListConfiguration: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.vendorDashboard.browserTitle",
  data() {
    return {
      listConfiguration: {
        subject: "brand",
        listSrc: "justopp/brand",
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: false, //bool, default false
        enableMassActions: false,
        createRoute: {
          name: "company-vendorId-dashboard-brands-create",
          params: { vendorId: this.vendorId },
        },
        editRoute: (item) => {
          this.$router.push({
            name: "company-vendorId-dashboard-brands-edit-brandId",
            params: { vendorId: this.vendorId, brandId: item.id },
          });
        },
        additionalListData: {
          simplified: false,
          translate: true,
        },
        constantFilters: {
          VendorId: this.vendorId,
        },
        // add filters: category
        // add sortings: price, endDate,
        noItemsFoundText: "justopp.vendorBrands.noBrands",
        fields: {
          // these are the table columns
          name: {
            itemKey: "name",
            label: "justopp.vendorBrands.fields.name",
            filterable: true, // boolean, or object
            orderable: true,
          },
          logoImage: {
            itemKey: "logoImage",
            label: "justopp.vendorBrands.fields.logoImage",
            orderable: false,
            filterable: false, // boolean, or object
          },
        },
        actions: {
          show: false,
          edit: true,
          delete: false,
        },
        ...this.overrideListConfiguration,
      },
      asyncData: {},
    };
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.no-word-break {
  word-break: normal;
}
</style>
